export default {"src":"/asasqt-service-app//_next/static/media/safari-pinned-tab.525e5713.svg","height":513,"width":513,"blurWidth":0,"blurHeight":0};